module.exports = __webpack_public_path__ + "img/66.77d758ec.jpg";